import React from 'react'

import InAppNotFound from './InAppNotFound'

const NotFound = () => (
  <div className="height-full-page flexbox flexbox-centered">
    <InAppNotFound />
  </div>
)

export default NotFound
